<template>
  <div>
    <div class="main-content">
      <div class="row">
        <!-- Botões de ação -->
        <div class="col-md-12 mb-2">
          <button class="btn btn-success mr-2" @click="exportToExcel">
            Exportar para Excel
          </button>
          <button class="btn btn-warning mr-2" @click="modelToExcel">
            Exportar Modelo
          </button>
          <button
            class="btn btn-info mr-2"
            data-toggle="modal"
            data-target="#modalImport"
          >
            Importar Modelo
          </button>
        </div>

        <!-- Card com filtros e tabela -->
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <!-- Botão Nova Movimentação -->
              <div class="row mb-3">
                <div class="col-md-12 d-flex justify-content-end">
                  <router-link to="/movimentos/add" class="btn btn-success">
                    <i class="fa fa-plus mr-1"></i> Nova Movimentação
                  </router-link>
                </div>
              </div>

              <!-- Filtros -->
              <div class="row mb-2">
                <div class="col-md-1">
                  <label>ID</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtros.id"
                    placeholder="Filtrar por ID"
                  />
                </div>
                <div class="col-md-3">
                  <label>Tipo de Movimentação</label>
                  <v-select
                    v-model="filtros.tipo_movimentacao_id"
                    class="vselect"
                    :options="tipo_movimentacoes"
                    :reduce="(tipo) => tipo.id"
                    label="nome"
                    placeholder="Selecione o tipo"
                  />
                </div>
                <div class="col-md-4">
                  <label>Usuários</label>
                  <v-select
                    v-model="filtros.usuarios"
                    class="vselect"
                    :options="usuarios"
                    :reduce="(user) => user.id"
                    label="name"
                    placeholder="Selecione os usuários"
                    multiple
                  />
                </div>
                <div class="col-md-4">
                  <label>Descrição</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtros.descricao"
                    placeholder="Filtrar por descrição"
                  />
                </div>
              </div>

              <!-- Botão Filtrar -->
              <div class="row mb-3">
                <div class="col-md-12 d-flex justify-content-end">
                  <button class="btn btn-primary" @click="filtrar">
                    <i class="fa fa-filter mr-1"></i> Filtrar
                  </button>
                </div>
              </div>

              <!-- Tabela -->
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th style="width: 5%">ID</th>
                      <th style="width: 20%">Tipo de Movimentação</th>
                      <th style="width: 40%">Descrição</th>
                      <th style="width: 20%">Usuário</th>
                      <th style="width: 15%">Ações</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="movimento in movimentos" :key="movimento.id">
                      <td>{{ movimento.id }}</td>
                      <td>
                        {{
                          movimento.tipo_movimentacao
                            ? movimento.tipo_movimentacao.nome
                            : "Indisponível"
                        }}
                      </td>
                      <td>{{ movimento.descricao || "Indisponível" }}</td>
                      <td>
                        {{
                          movimento.usuario
                            ? movimento.usuario.name
                            : "Indisponível"
                        }}
                      </td>
                      <td>
                        <button
                          class="btn btn-crud view mr-1"
                          @click="visualizar(movimento.id)"
                          title="Visualizar"
                        >
                          <i class="fa fa-eye"></i>
                        </button>
                        <button
                          class="btn btn-crud check"
                          @click="gerarPdf(movimento)"
                          title="Gerar PDF"
                        >
                          <i class="fa fa-file-pdf"></i>
                        </button>
                      </td>
                    </tr>
                    <tr v-if="movimentos.length === 0">
                      <td colspan="5" class="text-center">
                        Nenhum movimento encontrado
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Paginação -->
              <div class="row mt-3" v-if="total > 0">
                <div class="col-md-12">
                  <nav>
                    <ul class="pagination justify-content-center">
                      <li
                        class="page-item"
                        :class="{ disabled: currentPage === 1 }"
                      >
                        <a
                          class="page-link"
                          @click="mudarPagina(currentPage - 1)"
                        >
                          &lt;
                        </a>
                      </li>
                      <li
                        class="page-item"
                        v-for="page in paginasVisiveis"
                        :key="page"
                        :class="{ active: page === currentPage }"
                      >
                        <a class="page-link" @click="mudarPagina(page)">
                          {{ page }}
                        </a>
                      </li>
                      <li
                        class="page-item"
                        :class="{ disabled: currentPage === lastPage }"
                      >
                        <a
                          class="page-link"
                          @click="mudarPagina(currentPage + 1)"
                        >
                          &gt;
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="col-md-12">
                  <p class="text-center mb-2">
                    Mostrando {{ from }} de {{ to }} até {{ total }} de
                    registros
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de Importação -->
    <div class="ibox-title" style="padding: 16px">
      <div
        class="modal fade"
        id="modalImport"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modalImportTitle"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Importar</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div class="modal-body mt-1">
              <div class="row">
                <div class="col-md-4 mb-1">
                  <label>Tipo de Movimentação</label>
                  <v-select
                    v-model="tipo_movimentacao_id"
                    class="vselect"
                    :options="tipo_movimentacoes"
                    :reduce="(tipo_movimentacoes) => tipo_movimentacoes.id"
                    :label="'nome'"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label>Unidades</label>
                  <v-select
                    v-model="unidade_id"
                    class="vselect"
                    :options="unidades"
                    :reduce="(unidades) => unidades.id"
                    :label="'nome'"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label>Anexar</label>
                  <input
                    type="file"
                    class="form-control"
                    @change="handleFileUpload"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mb-1">
                  <label>Descrição</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="filtros.descricao"
                  />
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Fechar
              </button>
              <button type="button" class="btn btn-primary" @click="importar">
                Importar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      movimentos: [],
      usuarios: [],
      tipo_movimentacoes: [],
      unidades: [],
      filtros: {
        id: "",
        tipo_movimentacao_id: null,
        usuarios: [],
        descricao: "",
      },
      importacao: {
        tipo_movimentacao_id: null,
        unidade_id: null,
        descricao: "",
        arquivo: null,
      },
      // Paginação
      currentPage: 1,
      perPage: 10,
      total: 0,
      from: 0,
      to: 0,
      lastPage: 1,
      file: null,
      tipo_movimentacao_id: null,
      unidade_id: null,
    };
  },
  computed: {
    paginasVisiveis() {
      const paginas = [];
      const maxPaginas = 10;
      const inicio = Math.max(1, this.currentPage - Math.floor(maxPaginas / 2));
      const fim = Math.min(this.lastPage, inicio + maxPaginas - 1);

      for (let i = inicio; i <= fim; i++) {
        paginas.push(i);
      }

      return paginas;
    },
  },
  methods: {
    getMovimentos(page = 1) {
      const self = this;
      self.$loading(true);

      let api = `${self.$store.state.api}movimentos?page=${page}&limit=${self.perPage}&orderByDesc=id`;

      // Adicionar relacionamentos
      api += "&with[]=tipo_movimentacao&with[]=usuario";

      // Aplicar filtros
      if (self.filtros.id) {
        api += `&id=${self.filtros.id}`;
      }

      if (self.filtros.tipo_movimentacao_id) {
        api += `&tipo_movimentacao[nome]=${self.getTipoMovimentacaoNome(
          self.filtros.tipo_movimentacao_id
        )}`;
      }

      if (self.filtros.usuarios && self.filtros.usuarios.length > 0) {
        // Enviar array de IDs de usuários
        const nomesUsuarios = self.filtros.usuarios.map((id) => {
          const usuario = self.usuarios.find((u) => u.id === id);
          return usuario ? usuario.name : "";
        });

        // Enviar como parâmetro array
        nomesUsuarios.forEach((nome) => {
          if (nome) {
            api += `&usuarios_nomes[]=${encodeURIComponent(nome)}`;
          }
        });
      }

      if (self.filtros.descricao) {
        api += `&descricao=${encodeURIComponent(self.filtros.descricao)}`;
      }

      axios
        .get(api)
        .then((response) => {
          self.movimentos = response.data.data || [];
          self.total = response.data.count || 0;
          self.currentPage = response.data.current_page || 1;
          self.perPage = response.data.per_page || 10;
          self.lastPage = response.data.last_page || 1;
          self.from =
            response.data.data.length > 0
              ? (self.currentPage - 1) * self.perPage + 1
              : 0;
          self.to = Math.min(
            self.from + response.data.data.length - 1,
            self.total
          );

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, "Erro ao carregar movimentos", "error");
          console.error(error);
        });
    },

    filtrar() {
      this.currentPage = 1;
      this.getMovimentos(1);
    },

    mudarPagina(page) {
      if (page >= 1 && page <= this.lastPage) {
        this.currentPage = page;
        this.getMovimentos(page);
      }
    },

    getUsuarios() {
      const self = this;
      const api = `${self.$store.state.api}users?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.usuarios = response.data.data || [];
        })
        .catch((error) => {
          console.error("Erro ao carregar usuários:", error);
        });
    },

    getTipoMovimentacoes() {
      const self = this;
      const api = `${self.$store.state.api}tipo_movimentacoes?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.tipo_movimentacoes = response.data.data || [];
        })
        .catch((error) => {
          console.error("Erro ao carregar tipos de movimentação:", error);
        });
    },

    getUnidades() {
      const self = this;
      const api = `${self.$store.state.api}unidades?paginated=false`;

      axios
        .get(api)
        .then((response) => {
          self.unidades = response.data.data || [];
        })
        .catch((error) => {
          console.error("Erro ao carregar unidades:", error);
        });
    },

    getTipoMovimentacaoNome(id) {
      const tipo = this.tipo_movimentacoes.find((t) => t.id === id);
      return tipo ? tipo.nome : "";
    },

    visualizar(id) {
      this.$router.push(`/movimentos/view/${id}`);
    },

    gerarPdf(movimento) {
      // Usa o atributo 'file' que vem do append do modelo MovimentoEstoque
      if (movimento.file) {
        window.open(movimento.file, "_blank");
      } else {
        // Fallback caso o atributo não venha
        const url = `${this.$store.state.url}movimentos/pdf/${movimento.id}`;
        window.open(url, "_blank");
      }
    },

    exportToExcel() {
      const self = this;
      const dataInicio = self.filtros.data_inicio;
      const dataFim = self.filtros.data_fim;

      if (dataInicio || dataFim) {
        if (dataInicio && dataFim) {
          var url = `${self.$store.state.url}exportar_movimentos?data_inicio=${dataInicio}&data_fim=${dataFim} 23:59:59`;
          window.open(url, "_blank").focus();
        } else {
          self.$message(
            null,
            "Por favor, preencha ambos os campos de data.",
            "error"
          );
          return;
        }
      } else {
        var url = `${self.$store.state.url}exportar_movimentos`;
        window.open(url, "_blank").focus();
      }
    },

    modelToExcel() {
      const self = this;
      const dataInicio = self.filtros.data_inicio;
      const dataFim = self.filtros.data_fim;

      if (dataInicio || dataFim) {
        if (dataInicio && dataFim) {
          var url = `${self.$store.state.url}exportar_modelo?data_inicio=${dataInicio}&data_fim=${dataFim} 23:59:59`;
          window.open(url, "_blank").focus();
        }
      } else {
        var url = `${self.$store.state.url}exportar_modelo`;
        window.open(url, "_blank").focus();
      }
    },

    handleFileUpload(event) {
      this.file = event.target.files[0];
    },

    importar() {
      const formData = new FormData();

      formData.append("tipo_movimentacao_id", this.tipo_movimentacao_id);
      formData.append("unidade_id", this.unidade_id);
      formData.append("descricao", this.filtros.descricao);
      formData.append("user_id", this.$store.state.user.id);

      if (this.file) {
        formData.append("arquivo", this.file);
      }

      axios
        .post(`${this.$store.state.url}importar_modelo`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$message("Sucesso", "Importação realizada!", "success");
        })
        .catch((error) => {
          let mensagem = "Falha ao importar";

          if (error.response && error.response.data) {
            mensagem =
              error.response.data.error ||
              error.response.data.message ||
              mensagem;
          }

          this.$message("Erro", mensagem, "error");
        });
    },
  },
  mounted() {
    this.getUsuarios();
    this.getTipoMovimentacoes();
    this.getUnidades();
    this.getMovimentos();
  },
};
</script>

<style scoped>
.table-responsive {
  overflow-x: auto;
}

.pagination {
  margin-bottom: 0;
}

.page-link {
  cursor: pointer;
}

.page-item.disabled .page-link {
  cursor: not-allowed;
}
</style>
